<template>
  <section class="main-container">
    <div class="main-container__container">
      <div class="main-container__container__sep-cont"></div>
      <div class="main-container__container__tools-cont">
        <div class="main-container__container__tools-cont__row-one">
          <div class="main-container__container__tools-cont__row-one__group">
            <div class="main-container__container__tools-cont__row-one__group__datags-cont">
              <GolstatsData :custom="colorsConfig" />
            </div>
            <div class="main-container__container__tools-cont__row-one__group__tops-cont">
              <TopMini :custom="colorsConfig" :category="category" :is-premium-user="!!getUser" height="fit-content"/>
            </div>
          </div>
          <div class="main-container__container__tools-cont__row-one__media">
            <MediaPlayer
              :custom="colorsConfig"
              :gs-data="gsData"
              :is-first-row="isFirstRow"
              :is-player-user="isPlayer"
              :is-goalkeeper="isGoalkeeper"
            />
          </div>
        </div>
        <div class="main-container__container__tools-cont__row-two">
          <div class="main-container__container__tools-cont__row-two__calendar-cont">
            <Calendar
              :key="updatescroll"
              :custom="colorsConfig"
              await-for-seasons
              :gs-data="gsData"
              :seasons="seasonsBySelectedSeason"
              :is-second-row="isCalendarSecondRow"
              :is-cup="getIsCupTournament"
              :is-cup-legacy="isCupLegacy"
            />
          </div>
          <div class="main-container__container__tools-cont__row-two__table-cont">
            <template v-if="getIsCupTournament">
              <TableMundial :custom="colorsConfig" :seasonget="seasonSelected" :await-for-season="true" />
            </template>
            <template v-else>
              <Table :custom="colorsConfig" />
            </template>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
export default {
  name: 'ViewAll',
  components: {
    Table: () => import('@/components/Sections/Table/TableComponent'),
    TableMundial: () => import('@/components/Sections/Table/TableComponentMundial'),
    GolstatsData: () => import('@/views/GolstatsData'),
    TopMini: () => import('@/views/TopMini'),
    MediaPlayer: () => import('@/components/Sections/MediaPlayer-v3/Main'),
    Calendar: () => import('@/components/Sections/Calendar/CalendarComponent'),
  },
  watch: {
    seasonSelected() {
      this.updatescroll += 1;
    },
  },
  computed: {
    ...mapState({ windowWidth: 'windowWidth' }),
    ...mapState('loginGeneral', ['seasonSelected', 'seasonsByRegularSeason']),
    ...mapGetters('loginGeneral', [
      'getModal',
      'getUser',
      'getIsCupTournament',
      'getSeasonSelected',
      'isPlayer',
      'isGoalkeeper',
    ]),
    isCupLegacy() {
      return Number(this.seasonSelected) === 881;
    },
    gsData() {
      return {
        tournamentId: this.getUser.tournament,
        teamId: this.getUser.team,
        isGoalkeeper: this.getUser.isGoalkeeper,
      };
    },
    isFirstRow() {
      return this.windowWidth > 1308;
    },
    isCalendarSecondRow() {
      return this.windowWidth > 970;
    },
    seasonsBySelectedSeason() {
      let seasonsBySelectedSeason = null;
      seasonsBySelectedSeason = this.seasonsByRegularSeason.get(Number(this.seasonSelected));
      return seasonsBySelectedSeason || [];
    },
  },
  data() {
    return {
      category: { id: 1, name: 'Goles', bluer: false },
      seasonUpdate: 1535,
      updatescroll: 0,
      colorsConfig: {
        logo: 'https://golstatsimages.blob.core.windows.net/content/escudo_golstats.png',
        color: '#cbee6b',
        background: '#242424',
        colorheader: '#132839',
        backgroundheader: '#CCE8B5',
        headerBackground: '#132839',
        headerColor: '#CBEE6E',
        headerBorderColor: '#CBEE6E',
        header2Background: '#132839',
        header2Color: '#FFFFFF',
        subHeaderBackground: '#cbee6b',
        subHeaderColor: '#353535',
        headerBetToolBackground: '#242424',
        subheaderBetToolBackground: '#151515',
        bet_house: '',
        main_logo: '',
        secondary_logo: '',
        show_logo: false,
        url_base: '',
        type: 1,
        team_id: 0,
        categories: 'all',
      },
      lastSeasonSelected: null,
    };
  },
  methods: {
    ...mapMutations('profileconfigGeneral', ['setColorsConfig']),
  },
  created() {
    this.setColorsConfig(this.colorsConfig);
  },
};
</script>

<style lang="scss" scoped>
.open {
  height: 100px !important;
}
.line-separator {
  border-top: dashed 1px #94a8ba;
  margin: 0;
  width: 100%;
  height: 2px;
  top: 50%;
}
.main-container {
  display: inline-block;
  margin: 0 auto;
  max-width: 2000px;
  padding-bottom: 70px;
  width: 96.2%;
  border-radius: 21px;
  position: relative;
  box-shadow: 0 7px 24px 0 rgba(84, 124, 171, 0.12);
  background-color: #ffffff;
  &__container {
    width: 1270px;
    height: auto;
    margin: 0 auto;
    @media screen and (max-width: 1328px) {
      width: 98%;
    }
    &__menu-cont {
      width: 100%;
      height: 56px;
      @media screen and (max-width: 1000px) {
        height: 90px;
      }
      @media screen and (max-width: 400px) {
        height: 56px;
      }
    }
    &__sep-cont {
      width: 100%;
      height: 20px;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;

      &__text {
        position: absolute;
        font-family: Avenir-Medium, sans-serif;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: left;
        color: #000;
        background-color: white;
        padding: 0 10px;

        & > span {
          font-family: Avenir-Bold, sans-serif;
          font-weight: bold;
        }
      }

      @media screen and (max-width: 410px) {
        font-size: 0.75em;
      }
    }
    &__tools-cont {
      width: 100%;
      height: auto;
      position: relative;

      &__row-one {
        width: 100%;
        height: auto;
        display: inline-flex;
        margin-bottom: 32px;
        @media screen and (max-width: 1328px) {
          display: inline-block;
          margin-bottom: 22px;
        }
        &__group {
          width: 638px;
          display: inline-flex;
          height: auto;
          @media screen and (max-width: 1328px) {
            width: 100%;
          }
          @media screen and (max-width: 428px) {
            display: inline-block;
          }
          &__datags-cont {
            width: 302.5px;
            height: auto;
            display: inline-block;
            border: 1px solid #c0c0c0;
            @media screen and (max-width: 1328px) {
              width: 49%;
            }
            @media screen and (max-width: 628px) {
              width: 49.8%;
              height: 410px;
            }
            @media screen and (max-width: 428px) {
              width: 100%;
              height: 151px;
            }
          }
          &__tops-cont {
            width: 303.5px;
            height: 410px;
            // background: #e8e8e8;
            margin-left: 32px;
            display: inline-block;
            @media screen and (max-width: 1328px) {
              width: 49%;
              margin-left: 25px;
            }
            @media screen and (max-width: 628px) {
              margin-left: 2px;
              width: 49.8%;
              height: 410px;
            }
            @media screen and (max-width: 428px) {
              width: 100%;
              margin-left: 0%;
              margin-top: 25px;
            }
          }
        }
        &__media {
          width: 600px;
          margin-left: 32px;
          @media screen and (max-width: 1328px) {
            width: 100%;
            margin-left: 0;
            margin-top: 25px;
          }
          @media screen and (max-width: 828px) {
            width: 100%;
            margin-left: 0;
            margin-top: 25px;
          }
          @media screen and (max-width: 628px) {
            width: 100%;
            margin-left: 0;
            margin-top: 25px;
          }
        }
      }
      &__row-two {
        width: 100%;
        height: auto;
        display: inline-flex;
        margin-bottom: 32px;
        @media screen and (max-width: 1328px) {
          margin-bottom: 25px;
        }
        @media screen and (max-width: 970px) {
          flex-direction: column;
          align-items: center;
        }
        &__calendar-cont {
          width: 638px;
          @media screen and (max-width: 1328px) {
            width: 49%;
          }
          @media screen and (max-width: 970px) {
            width: 100%;
          }
        }
        &__table-cont {
          width: 602px;
          height: auto;
          margin-left: 32px;
          @media screen and (max-width: 1328px) {
            margin-left: 25px;
            width: 49%;
          }
          @media screen and (max-width: 970px) {
            width: 100%;
            margin-left: 0px;
            margin-top: 25px;
          }
        }
      }
    }
  }
}
</style>
